exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infopane{position:fixed;top:0;right:0;z-index:2000;border:1px solid red;background:#fff;padding:1em}", ""]);

// exports
